import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ServiceProviderIndex from "../../../components/SidetabPages/ServiceProvider/ServiceProviderIndex";

const ServiceProvider = () => {
  return (
    <>
      <AnnouncementBar />
      <ServiceProviderIndex />
    </>
  );
};
export default ServiceProvider;
